import { createStorage } from '@emfit/shared-store';

/**
 * Care app storage instance with 'care' namespace.
 * This prevents localStorage collisions with QS app during development.
 *
 * Keys stored: token, userData, etc.
 * Stored under: localStorage['store:care']
 */
export const Storage = createStorage('care');

/**
 * Get a namespaced localStorage key for direct localStorage access.
 * Use this for keys that need to be accessed outside of Storage (e.g., 'lang', 'theme').
 */
export function getStorageKey(key: string): string {
  return `care:${key}`;
}
